var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "timeslot-item", class: { "--selected": _vm.isSelected } },
    [
      _c("div", { staticClass: "timeslot-item__header" }, [
        _c("div", { staticClass: "timeslot-item__info" }, [
          _c("h2", { staticClass: "timeslot-item__label" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.tc(
                    "spaSoft.step1.itinerarySelection.timeSlotNumberLabel",
                    { slotNumber: _vm.index + 1 }
                  )
                ) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("h3", { staticClass: "timeslot-item__time" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.getTimeslotTimeRange(_vm.data.guestAvailabilities)) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "timeslot-item__select" }, [
          _c("div", { staticClass: "input radio" }, [
            _c("input", {
              attrs: {
                id: "timeslot-" + (_vm.index + 1),
                name: "timeslot",
                type: "radio",
              },
              domProps: { checked: _vm.isSelected, value: _vm.data.index },
              on: {
                input: function ($event) {
                  return _vm.handleSelectItinerary(_vm.data)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "sr-only",
                attrs: { for: "timeslot-" + (_vm.index + 1) },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.tc(
                        "spaSoft.step1.itinerarySelection.timeSlotNumberLabel",
                        { slotNumber: _vm.index + 1 }
                      )
                    ) +
                    ", " +
                    _vm._s(
                      _vm.getTimeslotTimeRange(_vm.data.guestAvailabilities)
                    ) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._l(_vm.data.guestAvailabilities, function (guestData, guestIndex) {
        return _c(
          _vm.isMobile ? "TimeslotTableMobile" : "TimeslotTableDesktop",
          {
            key: "guest-" + guestIndex,
            tag: "component",
            attrs: { "guest-data": guestData, index: guestIndex },
          }
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }